<template>
  <!--教师评价-->
  <a-modal :visible="visible" @cancel="evaluateCancel"
           :destroyOnClose="true" :footer="null"
           width="1000px">
    <div slot="title" class="evaluate-title">
      <h2>{{ step === 1 ? pageInfo.realName : "教师评价" }}</h2>
      <a-descriptions v-show="step === 1" size="small" :column="3">
        <a-descriptions-item label="性别">{{ pageInfo.gender === 1 ? "男" : "女" }}</a-descriptions-item>
        <a-descriptions-item label="班级">{{ pageInfo.gradeName + pageInfo.className }}</a-descriptions-item>
        <a-descriptions-item label="出生日期">
          {{ pageInfo.birthday ? pageInfo.birthday.split(" ")[0] : "" }}
        </a-descriptions-item>
      </a-descriptions>
    </div>
    <div v-show="step === 1" class="evaluate-modal">
      <a-descriptions :column="2"
                      style="margin-bottom: 5px;">
        <a-descriptions-item label="课时得分">{{ studentReport.data.score }}</a-descriptions-item>
        <!-- <a-descriptions-item v-if="pageInfo.childCourseType!=1" label="课时获星">
          <a-icon type="star" theme="filled" style="font-size: 18px; color: #fadb14;"/>
          x {{ studentReport.data.childCourseStar }}
        </a-descriptions-item> -->
      </a-descriptions>
      <a-table :columns="studentReport.columns"
               :loading="studentReport.table.tableLoading"
               :dataSource="studentReport.table.tableDataSource"
               :scroll="{y: 350}"
               :pagination="false">
        <div slot="ability" slot-scope="text" class="table-ability">
          <div v-for="ability in text.abilitys"
               class="ability"
               :key="ability.name">
            <div :style="`background-color: ${ ability.color }`" class="back"></div>
            <img :src="ability.icon | filterUrl" alt="">
            <i :style="`color: ${ ability.color }`">{{ ability.name }}</i>
          </div>
        </div>
        <div slot="point" slot-scope="text" class="table-stage">
          <span v-if="text.contentType != 2">--</span>
          <span v-if="text.contentType == 2">{{ text.stage }}</span>
          <span style="font-size:12px;" v-if="text.stageISPromote && text.contentType == 2"><img
            src="@/assets/evaluate/cd-vector.png" />+{{ text.stageDifferenceScore }}</span>
        </div>
        <div slot="accuracy" slot-scope="text" class="table-stage">
          <span v-if="text.completionTimes < 1">--</span>
          <span v-else>{{ text.accuracy == "NaN" || text.accuracy < 0 ? "--" : (text.accuracy + "%") }}</span>
        </div>
        <div slot="time" slot-scope="text">{{ text.completionTimes < 1 ? "--" : SecondsToTime(text.timeConsuming) }}
        </div>
        <div slot="star" slot-scope="text" class="table-star">
          <div v-if="text.completionTimes < 1">--</div>
          <div v-else>
            <a-icon type="star" theme="filled" style="font-size: 18px; color: #fadb14;" />
            <span>x{{ text.star }}</span>
          </div>
        </div>
        <div slot="score" slot-scope="text" style="white-space: nowrap;">
          <div v-if="text.completionTimes < 1">--</div>
          <div v-else>
            <img class="group" src="@/assets/evaluate/trophy-colour.png" alt="">
            <span>&nbsp;{{ text.maxScore }}</span>
            <span style="font-size:12px;" v-if="text.scoreISPromote">
                            <img src="@/assets/evaluate/cd-vector.png"
                                 style="width: 12px;margin:0 4px 0 6px;" />+{{ text.scoreDifferenceScore }}</span>
          </div>
        </div>
      </a-table>
    </div>
  </a-modal>
</template>

<script>
import { tableRelevant, SecondsToTime } from "@/pages/projectImpl/js/utils";

const studentReportColumns = [
  { title: "名称", dataIndex: "contentName" },
  { title: "能力维度", scopedSlots: { customRender: "ability" } },
  { title: "关卡", scopedSlots: { customRender: "point" } },
  { title: "正确率", scopedSlots: { customRender: "accuracy" } },
  { title: "用时", scopedSlots: { customRender: "time" } },
  // {title: '星级', scopedSlots: {customRender: 'star'}},
  { title: "得分", scopedSlots: { customRender: "score" } },
  { title: "完成时间", dataIndex: "lastCompletionDate", align: "center" },
];
export default {
  name: "TeacherEvaluation",
  model: {
    prop: "visible",
    event: "change",
  },
  props: {
    pageInfo: Object,
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      SecondsToTime,
      confirmLoading: false,
      step: 1,
      studentReport: {
        visible: false,
        data: {},
        columns: studentReportColumns,
        table: tableRelevant.call(this),
      },
      userEvaluation: { emotion: {}, teacherEvaluation: { scores: [] }, objectives: [] },
    };
  },
  watch: {
    pageInfo() {
      // this.getUserEvaluation();
      this.lookStudentReport();
    },
  },
  methods: {
    getUserEvaluation() {
      const params = {
        userChildCourseId: this.pageInfo.projectCourseChildUserId,
      };
      this.userEvaluation = { emotion: {}, teacherEvaluation: { scores: [] }, objectives: [] };
      this.$http.CourseCenter.getUserEvaluation(params).then(res => {
        const { data } = res;
        if (typeof data !== "object" || typeof data.currentEvaluationDetail !== "object") {
            return;
          }
          this.userEvaluation = data.currentEvaluationDetail;
          this.userEvaluation.emotion = this.userEvaluation.evaluationList.filter(f => f.evaluationType == 2)[0] || {};
          this.userEvaluation.teacherEvaluation = this.userEvaluation.evaluationList.filter(f => f.evaluationType == 3)[0];
          if (this.userEvaluation.teacherEvaluation) {
            this.userEvaluation.teacherEvaluation.iframeUrl = this.userEvaluation.teacherEvaluation.url
              + `?questionGroupId=${this.userEvaluation.teacherEvaluation.questionGroupId}&url=${(process.env.VUE_APP_API_BASE_URL).split("//")[1]}`;
          }
      });
    },
    lookStudentReport() {
      this.studentReport.table.tableLoading = true;
      this.$http.CourseLearningService.getUserCourseChildScore(this.pageInfo.projectCourseChildUserId)
        .then(res => {
          this.studentReport.data = res.data;
          this.studentReport.table.tableDataSource = res.data.courseSessionContentSettlements.map(m => ({
            ...m,
            lastCompletionDate: m.completionTimes < 1 ? "未开始" : m.lastCompletionDate,
          }));
        })
        .finally(() => {
          this.studentReport.table.tableLoading = false;
        });
    },
    // 教师评价确认
    evaluateOK() {
      this.step = 2;
      window.addEventListener("message", this.evaluateGameData);
    },
    // 教师评价取消
    evaluateCancel() {
      window.removeEventListener("message", this.evaluateGameData);
      this.step = 1;
      this.$emit("change", false);
    },
    evaluateGameData(value) {
      if (value.data.gameEnd) {
        this.getUserEvaluation();
        this.step = 1;
        this.pageInfo.teacherEvaluate = true;
        if (typeof this.$parent.getModleList === "function") {
          this.$parent.getModleList(this.pageInfo);
        }
        if (typeof this.$parent.getList === "function") {
          this.$parent.getList();
        }
        this.$emit("change", false);
        return;
      }
      if (value.data.startTime === 0 || value.data.startTime || value.data.levelEnd) {
        console.log(value.data);
        const json = {
          userChildCourseId: this.pageInfo.projectCourseChildUserId,
          questionGroupId: this.userEvaluation.teacherEvaluation.questionGroupId,
          evaluationType: this.userEvaluation.teacherEvaluation.evaluationType,
          orginalData: value.data.orginalData,
        };
        this.$http.CourseCenter.saveEvaluation(json).then(res => {
          const { message } = res;
          this.$message.success(message);
        });
      }
    },
  },
};
</script>

<style scoped lang="less">
.evaluate-title {
  display: flex;

  h2 {
    font-size: 16px;
    white-space: nowrap;
    margin-right: 100px;
    color: #000;
    font-weight: bold;
    margin-bottom: 0;
  }
}

.evaluate-modal {
  max-height: 450px;
  overflow-y: auto;

  /deep/ .ant-descriptions-item-label {
    color: #000;
    font-weight: bold;
  }

  .star {
    font-size: 20px;
    margin-left: 5px;
    vertical-align: bottom;
  }

  .table-ability, .table-stage {
    img {
      width: 12px;
      height: 12px;
      margin-right: 2px;
    }

    i {
      font-size: 12px;
      font-style: normal;
      white-space: nowrap;
    }

    .ability {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px;
      padding: 0 5px;
      height: 22px;
      line-height: 22px;
      margin-right: 5px;
      margin-bottom: 5px;
      position: relative;
      overflow: hidden;
      z-index: 5;
    }

    .back {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      z-index: 4;
      opacity: 0.34;
    }
  }

  .table-star {
    display: flex;
    align-items: center;

    img {
      width: 14px;
      margin-right: 5px;
    }
  }

  .ant-descriptions {
    margin-bottom: 20px;
  }

  .emotion {
    display: flex;
    align-items: center;
    color: #000;
    font-weight: bold;
    margin-bottom: 20px;

    .star:nth-of-type(1) {
      margin-left: 20px;
    }

    /deep/ p {
      margin: 0;
    }
  }

  .evaluate-game {
    display: flex;
    align-items: center;

    img {
      width: 32px;
      height: 32px;
      object-fit: cover;
      border-radius: 50%;
      margin-right: 15px;
    }

    h4 {
      font-size: 16px;
      color: #000;
      margin-bottom: 5px;
    }

    .ability-box {
      width: 220px;
      height: 25px;
      overflow: hidden;

      span {
        background: rgba(12, 142, 209, 0.55);
        color: red;
        padding: 1px 5px;
        border-radius: 5px;
        font-size: 13px;
        white-space: nowrap;

        &:not(:first-child) {
          margin-left: 5px;
        }
      }
    }
  }

  .dimension {
    margin-left: 25px;
  }
}

.evaluate-iframe {
  width: 100%;
  height: 450px;
}
</style>
